import React from "react";
import { PaymentNoticeCommentBoxArchives } from "./PaymentNoticeCommentBoxArchives";
import { PaymentNoticeCommentBoxInput } from "./PaymentNoticeCommentBoxInput";

export const PaymentNoticeCommentBox: React.FC = () => {
  return (
    <section>
      <PaymentNoticeCommentBoxInput />
      <PaymentNoticeCommentBoxArchives />
    </section>
  );
};
